import {UserEffects} from './user';
import {QuoteEffects} from './quote';
import {TranslationEffects} from './translation';

export const effects: any[] = [UserEffects, QuoteEffects, TranslationEffects];


